import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import icons from "../icons";
import { Link } from 'react-router-dom';
import APIUrls from "../services/APIUrls";
import { provisioningApiGetRequest , provisioningApiPostRequest} from "../services/authApiRoutes/APImethods";
import  { useEffect, useRef, useState } from "react";
import Select from "react-select";
import $ from "jquery";

export default function ProfileCompletionForm() {
  const navigate = useNavigate();
  const [params ,setParams] = useSearchParams();
  const tokenParam = params.get('token');
  const cbidParam = params.get('cbid');
  const [locales, setLocales] = useState([]);
  const [timeZones, setTimeZones] = useState([]);
  const [selectedLocale, setSelectedLocale] = useState();
  const [selectedTimeZone, setSelectedTimeZone] = useState();
  const ssoUserEmail = params.get('email');

  const navigateToLogin = () => {
    navigate("/");
  };

    const handleTimeZoneSelect = (event) => {
      var selectedZone = event.value;
      setSelectedTimeZone(selectedZone);
    };

    const handleLocaleSelect = (event) => {
      var selectedLocale = event.value;
      setSelectedLocale(selectedLocale);
    };



  useEffect( ()=>{

    provisioningApiGetRequest(APIUrls.GET_UNAUTH_LOCALES_LIST,ssoUserEmail).then((res) => {
          var options = [];
          res.data.data.map((lang) =>
            options.push({
              label: lang.display,
              value: lang
            })
          );
          setLocales(options);
    });

    provisioningApiGetRequest(APIUrls.GET_UNAUTH_TIMEZONE_LIST,ssoUserEmail).then((res) => {
          var options = [];
          res.data.data.map((zone) =>
              options.push({
                label: zone.localizedName,
                value: zone
              })
          );
          setTimeZones(options);
    });


  },[])

  const updateProfile = (event) =>{

    if(selectedLocale && selectedTimeZone){
        const form = {
                locale : selectedLocale.value,
                timeZone : selectedTimeZone.id,
                token : tokenParam
              };
        provisioningApiPostRequest(APIUrls.UPDATE_UNAUTH_PROFILE, ssoUserEmail, form).then((res) => {
            if(res.status == 200){
                $("#sso-redirect-form").submit();
            }
        });
    }
  }

  return (
    <div className="wrapper">
      <div className="sign-page">
        <div className="content">
          <div className="back" >
            <button type="button" onClick={navigateToLogin}>
              <i aria-hidden="true"></i>Back
            </button>
          </div>
          <div className="small-container">
            <div className="logo-block">
              <Link to="/">
                <img src={icons.OPAL_LOGO} alt="Logo" />
              </Link>
            </div>
            <div className={"inner-content-wrap update-password "}>
              <h1> Complete Your Profile</h1>
                <div className="wrap-form">
                  <div className="input-group">
                    <Select classNamePrefix='cw'
                        className="global-dropdown-select"
                        placeholder="Select Locale"
                        aria-label="Locale"
                        options={locales}
                        onChange={(e) => handleLocaleSelect(e)}
                    />
                  </div>

                  <div className="input-group">
                    <Select classNamePrefix='cw'
                        className="global-dropdown-select"
                        placeholder="Select Timezone"
                        aria-label="Timezone"
                        options={timeZones}
                        onChange={(e) => handleTimeZoneSelect(e)}
                    />
                  </div>

                  <div className="form-button">
                    <button className="btn" onClick={()=> updateProfile()}>
                      Update Profile
                    </button>
                  </div>
                </div>
                <form id="sso-redirect-form" action={process.env.REACT_APP_BACKEND_SERVER+"/sso/redirect"} method="post">
                    <input type="hidden" name="cbid" value={cbidParam? cbidParam : ""}/>
                    <input type="hidden" name="redirectTo" value="/dashboard"/>
                </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
